/* eslint-disable  */
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { prod } from 'src/config';

export const useFeatureFlag = (flagKey: string) => {
	if (prod) {
		return useFeatureFlagEnabled(flagKey);
	}
	return true;
};
